<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <modal-select modal="bestof-modal" v-validate="'required'" name="campaign_id" :readonly="item.id>0" :item-id="item.campaign_id" :item-name="item.campaign_id?item.campaign.data.name:''" v-on:select-item="selectCampaign"  :state="validateState('campaign_id')" placeholder="Campanha" label="Campanha" ></modal-select>
          <modal-select modal="dsr-modal" v-validate="'required'" name="dsr_id" :readonly="item.id>0" :item-id="item.dsr_id" :item-name="item.dsr?item.dsr.data.name:''" v-on:select-item="selectDsr"  :state="validateState('dsr_id')" placeholder="DSR" label="DSR" ></modal-select>


          <modal-select modal="zones-modal" v-validate="'required'" name="zone" :readonly="item.id>0" :item-id="item.zone" :item-name="item.zone" v-on:select-item="selectZone"  :state="validateState('zone')" placeholder="Zona" label="Zona" ></modal-select>

          <b-form-row>
            <b-col md="4">
              <b-form-group label="Valor">
                <b-form-input type="number" step="0.01" min="0" name="value" v-model="item.value" placeholder="Valor"  v-validate="'required'" :state="validateState('value')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('value') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Operadores">
                <b-form-input type="number" step="1" min="0" name="operators" v-model="item.operators" placeholder="Operadores"  v-validate="'required'" :state="validateState('operators')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('operators') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Quantidade">
                <b-form-input type="number" step="1" min="0" name="quantity" v-model="item.quantity" placeholder="Quantidade"  v-validate="'required'" :state="validateState('quantity')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('quantity') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'bestof_dsrobjectives.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>

import Zones from '@/views/dealers/zones/modal.vue'
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: {  Zones },
  data() {
    return {
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        zone: '',
        campaign: {
          data: {
            id: null,
            name: ''
          }
        },
        dsr: {
          data: {
            name: '',
            id: null
          }
        },
        value: 0,
        quantity: 0,
        operators: 0
      }
    }
  },
  methods: {
    selectDsr(e) {
      this.item.dsr_id = e.item.id
      this.item.dsr.data = e.item
    },
    selectCampaign(e) {
      this.item.campaign_id = e.item.id
      this.item.campaign.data = e.item
    },
    selectZone(e) {
      this.item.zone = e.item.zone
    },
    doShowModal(type) {
      this.modalType = type
      this.$refs.dealersModal.show()
    },
    hideModal() {
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('bestof/dsrobjectives' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'bestof_dsrobjectives.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('bestof/dsrobjectives', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'bestof_dsrobjectives.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('bestof/dsrobjectives' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'bestof_dsrobjectives.index'
          })
        })
    } else {
      this.dataLoaded =true
    }
  }
}
</script>
